<div class="analysis-creation-dialog">
  <p-dialog [(visible)]="showModal" [modal]="true" [dismissableMask]="true" [closable]="true" [draggable]="false"
    styleClass="qubit w-40" (onHide)="closeDialog()" [header]="appName">
    @if (appName === 'PollyPhi™ Relative LCMS') {
      <div class="p-1">
        <p> The PollyPhi™ Relative LC-MS workflow has been deprecated, only to give you the all-new El-MAVEN PollyPhi™
          Workflow! The El-MAVEN PollyPhi™ workflow allows you to perform <br> </p>
          <ul>
            @for (text of phiDeprecatedText; track text) {
              <li>
                <p>{{text}}</p>
              </li>
            }
          </ul>
          <br>
            <p> Watch <a [href]="pollyphiWebinarUrl" target="_blank">this</a> webinar to
            understand this workflow with Stable Isotope Resolved Metabolomics, SIRM
            data.
            <br><br>
            In case of any concerns or suggestions, please drop us an email at
            <a href="mailto:{{productEmail}}" target="_blank">{{ 'product@elucidata.io' }}</a>
          </p>
        </div>
      }
    </p-dialog>
  </div>

